// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__264Lw","buttons":"SendReceipts_buttons__6gGmR","email":"SendReceipts_email__pdKY0","bookApptTitle":"SendReceipts_bookApptTitle__33Zx9"};